import { render, staticRenderFns } from "./ToastNotification.vue?vue&type=template&id=854f5b96&scoped=true&"
import script from "./ToastNotification.vue?vue&type=script&lang=js&"
export * from "./ToastNotification.vue?vue&type=script&lang=js&"
import style0 from "./ToastNotification.vue?vue&type=style&index=0&id=854f5b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854f5b96",
  null
  
)

export default component.exports